import React from 'react';
import { OpenApiRouteResultType } from '../../../../../common/src/routes/openApiTypes';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetchGet } from '../../../store/openApiFetch';
import {
    PanelBody,
    PanelHeading,
    PanelWithoutForm,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
} from '../../elements';
import { InvestigationPriorityLabel } from '../../utils/InvestigationPriorityLabel';

export function SurveyDetailsFmecaFurtherInvestigations(props: { surveyId: string }) {
    const translate = useTranslate();

    const [items, setItems] = React.useState<OpenApiRouteResultType<'/api/surveys/{surveyId}/fmecaFurtherInvestigations', 'get'>>([]);

    React.useEffect(() => {
        const fetchData = async () => {
            const response = await openApiFetchGet('/api/surveys/{surveyId}/fmecaFurtherInvestigations', {
                surveyId: props.surveyId,
            });
            setItems(response);
        };
        void fetchData();
    }, [props.surveyId]);

    return (
        <PanelWithoutForm id="FmecaFurtherInvestigations">
            <PanelHeading text={translate('fmecaFurtherInvestigation.furtherInvestigation')} icon="fa fa-table"></PanelHeading>
            <PanelBody noPadding={true} whiteBackground={true}>
                <Table>
                    <TableHead>
                        <TableHeadRow light>
                            <TableHeader>{translate('common.location')}</TableHeader>
                            <TableHeader>{translate('common.description')}</TableHeader>
                            <TableHeader>{translate('common.priority')}</TableHeader>
                        </TableHeadRow>
                    </TableHead>
                    <TableBody>
                        {items.map((item) => (
                            <TableRow key={item.id}>
                                <TableData>
                                    {item.unit.element.name}
                                    <br />
                                    {item.unit.name}{' '}
                                    {item.manifestation.name && (
                                        <>
                                            <br />
                                            {item.manifestation.name}
                                        </>
                                    )}
                                </TableData>
                                <TableData>{item.description}</TableData>
                                <TableData>
                                    <InvestigationPriorityLabel value={item.priority} />
                                </TableData>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </PanelBody>
        </PanelWithoutForm>
    );
}
